import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type { CalculateQuotePayload } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  isUnderwritingAnalysisRequiredError,
  UnderwritingAnalysisRequiredError,
} from '../business/use-calculate-quote.hook';

export { isUnderwritingAnalysisRequiredError, UnderwritingAnalysisRequiredError };

export function useCalculateCapitalGlobalQuote() {
  const queryClient = useQueryClient();

  return useMutation({
    retry: false,
    mutationFn: async (payload: CalculateQuotePayload) => {
      const response = await capitalGlobalQuotesService.calculateQuote(payload);

      if (!response.success || !response.data) {
        if (Array.isArray(response.underwritingMessages)) {
          throw new UnderwritingAnalysisRequiredError(
            payload.policyId,
            response.underwritingMessages,
          );
        }
        throw new Error(response.error || 'Erro ao calcular cotação');
      }

      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.policyId],
      });
    },
    onError: (error, variables) => {
      if (isUnderwritingAnalysisRequiredError(error)) {
        queryClient.invalidateQueries({
          queryKey: ['proposal-details', variables.policyId],
        });
      }
    },
  });
}
